module.exports = __webpack_public_path__ + "media/images/front/treatment_support/setting_add_home_screen/img09-dc66593ddf3f056be82ee9a9eeb2ed29.png";